import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Impressum() {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Add Schema.org JSON-LD for Organization
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "SMC Simon Müller Consulting e.K.",
      "legalName": "SMC Simon Müller Consulting e.K.",
      "url": typeof window !== 'undefined' ? window.VITE_SITE_URL || "https://reputrust.ai" : "https://reputrust.ai",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Bissinger Str. 27",
        "addressLocality": "Lenningen",
        "postalCode": "73252",
        "addressCountry": "DE"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+49-7026-3999988",
        "contactType": "customer service",
        "email": "info@reputrust.ai",
        "availableLanguage": "German"
      },
      "vatID": "DE350766669"
    });
    document.head.appendChild(schemaScript);

    // Update page title
    document.title = "Impressum | SMC Simon Müller Consulting e.K. | reputrust.ai";

    return () => {
      if (schemaScript.parentNode) {
        schemaScript.parentNode.removeChild(schemaScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-600 selection:bg-tron-primary/30 selection:text-[#0F172A]">
      <Header />

      <div className="pt-32 pb-20 relative overflow-hidden">
        {/* Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-96 h-96 bg-tron-primary/10 rounded-full blur-[100px] animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-tron-secondary/10 rounded-full blur-[100px] animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>

        {/* Content */}
        <div className="max-w-[900px] mx-auto px-6 relative z-10">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200">
            <h1 className="text-3xl md:text-4xl font-bold text-[#0F172A] mb-8 border-b border-slate-200 pb-6" style={{ fontFamily: 'Inter Tight, sans-serif' }}>
              Impressum
            </h1>

            <div className="prose prose-slate prose-lg max-w-none" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              <p className="text-slate-600 leading-relaxed mb-4 mt-8">
                <strong className="text-[#0F172A]">SMC Simon Müller Consulting e.K.</strong><br />
                Bissinger Str. 27<br />
                73252 Lenningen<br />
                Deutschland
              </p>

              <p className="text-slate-600 leading-relaxed mb-4">
                Powered by <a href="https://youniverse.at" target="_blank" rel="noopener noreferrer" className="text-transparent bg-clip-text bg-gradient-to-r from-[#10B981] to-[#1E3A8A] font-medium hover:opacity-80 transition-opacity">Youniverse.at</a>
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Kontakt</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                <strong className="text-[#0F172A]">Telefon:</strong> 07026-39999 88<br />
                <strong className="text-[#0F172A]">E-Mail:</strong> <a href="mailto:info@reputrust.ai" className="text-transparent bg-clip-text bg-gradient-to-r from-[#10B981] to-[#1E3A8A] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors duration-300">info@reputrust.ai</a>
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Vertreten durch</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Simon Müller (Inhaber)
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Registereintrag</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Eintragung im Handelsregister<br />
                Registergericht: Amtsgericht Stuttgart<br />
                Registernummer: HRA 738663
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Umsatzsteuer-ID</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                DE350766669
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Simon Müller<br />
                Bissinger Str. 27<br />
                73252 Lenningen
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">EU-Streitschlichtung</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-transparent bg-clip-text bg-gradient-to-r from-[#10B981] to-[#1E3A8A] hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors duration-300">
                  https://ec.europa.eu/consumers/odr
                </a><br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Verbraucherstreitbeilegung/<br className="hidden sm:block" />Universalschlichtungsstelle</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Haftung für Inhalte</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Haftung für Links</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>

              <h2 className="text-xl md:text-2xl font-semibold text-[#0F172A] mt-8 mb-4 border-l-4 border-tron-primary pl-4">Urheberrecht</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
